module.exports = __webpack_public_path__ + "img/86055600.4df5e365.png";